// extracted by mini-css-extract-plugin
module.exports = {"box":"box","box__header":"box__header","box__button":"box__button","box__content":"box__content","box__tag":"box__tag"};